import { ComponentStyleConfig, theme as baseTheme } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

const {
  checkbox: { bgColor, bgHoverColor, borderColor, checkedBgColor, checkedBorderColor, checkmarkIconColor }
} = primaryColor

export const Checkbox: ComponentStyleConfig = {
  parts: ['control'],
  baseStyle: {
    ...baseTheme.components.Checkbox.baseStyle,
    control: {
      bg: bgColor,
      borderColor,
      _checked: {
        bg: checkedBgColor,
        borderColor: checkedBorderColor,
        _hover: {
          bg: bgHoverColor,
          borderColor: bgHoverColor,
        }
      },
      _icon: {
        color: checkmarkIconColor,
      },
    }
  },
}
